// import React, { useState } from 'react';
// import './DeleteProfile.css';

// const DeleteProfile = ({ onCancel, onDelete }) => {
//   const [selectedReason, setSelectedReason] = useState(null);
//   const [reasons] = useState([
//     { id: 1, text: 'Found My Match' },
//     { id: 2, text: 'Taking a Break' },
//     { id: 3, text: 'Unsatisfactory Experience' },
//     { id: 4, text: 'Reason not mentioned here' },
//   ]);

//   const handleReasonSelect = (id) => {
//     setSelectedReason(id === selectedReason ? null : id);
//   };

//   return (
//     <div className="delete-profile">
//       <h2 className="delete-profile__heading">Why do you want to delete your Profile?</h2>

//       <ul className="delete-profile__reasons">
//         {reasons.map((reason) => (
//           <li 
//             key={reason.id}
//             className={`reason-item ${selectedReason === reason.id ? 'selected' : ''}`}
//             onClick={() => handleReasonSelect(reason.id)}
//           >
//             <div className="checkbox-container">
//               <div className="custom-checkbox">
//                 {selectedReason === reason.id && <div className="checkmark">✓</div>}
//               </div>
//               <span>{reason.text}</span>
//             </div>
//           </li>
//         ))}
//       </ul>

//       <div className="contact-support">
//         <p className="contact-text">Having trouble using Shaadi.com?</p>
//         <div className="contact-methods">
//           <a href="tel:+918095031111" className="phone-link">+91 9090909090</a>
//           <span className="separator">|</span>
//           <a href="#" className="chat-link">💬 Chat with us</a>
//         </div>
//       </div>

//       <div className="action-buttons">
//         <button className="cancel-btn" onClick={onCancel}>Cancel</button>
//         <button 
//           className="delete-btn" 
//           onClick={onDelete}
//           disabled={!selectedReason}
//         >
//           Delete Profile
//         </button>
//       </div>
//     </div>
//   );
// };

// export default DeleteProfile;



import React, { useState } from 'react';
import './DeleteProfile.css';

const DeleteProfile = ({ onCancel, onDelete }) => {
    const [selectedReason, setSelectedReason] = useState(null);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [reasons] = useState([
        { id: 1, text: 'Found My Match' },
        { id: 2, text: 'Taking a Break' },
        { id: 3, text: 'Unsatisfactory Experience' },
        { id: 4, text: 'Reason not mentioned here' },
    ]);

    const handleReasonSelect = (id) => {
        setSelectedReason(id === selectedReason ? null : id);
    };

    const handleDeleteConfirmation = async () => {
        setIsDeleting(true);
        setErrorMessage('');

        try {
            const selectedReasonText = reasons.find(r => r.id === selectedReason)?.text;
            const token = localStorage.getItem('saptvidhiUserToken');
            const response = await fetch('https://saptavidhi-api.onrender.com/api/profile/deactive', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({
                    reason: selectedReasonText || 'No reason provided'
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to delete profile');
            }

            //     onDelete(); // Notify parent component
            //     setShowConfirmation(false);
            // } catch (error) {
            //     setErrorMessage(error.message || 'Something went wrong. Please try again.');
            // } finally {
            //     setIsDeleting(false);
            // }
            // Clear local storage and redirect
            localStorage.clear();
            window.location.href = '/login';
        } catch (error) {
            setErrorMessage(error.message || 'Something went wrong. Please try again.');
        } finally {
            setIsDeleting(false);
        }
    };
    

    return (
        <div className="delete-profile">
            <h2 className="delete-profile__heading">Why do you want to delete your Profile?</h2>

            <ul className="delete-profile__reasons">
                {reasons.map((reason) => (
                    <li
                        key={reason.id}
                        className={`reason-item ${selectedReason === reason.id ? 'selected' : ''}`}
                        onClick={() => handleReasonSelect(reason.id)}
                    >
                        <div className="checkbox-container">
                            <div className="custom-checkbox">
                                {selectedReason === reason.id && <div className="checkmark">✓</div>}
                            </div>
                            <span>{reason.text}</span>
                        </div>
                    </li>
                ))}
            </ul>

            <div className="contact-support">
                <p className="contact-text">Having trouble using Saptavidhi?</p>
                <div className="contact-methods">
                    <a href="tel:+918095031111" className="phone-link">+91 9090909090</a>
                    <span className="separator">|</span>
                    <a href="#" className="chat-link">💬 Chat with us</a>
                </div>
            </div>

            <div className="action-buttons">
                <button className="cancel-btn" onClick={onCancel}>Cancel</button>
                <button
                    className="delete-btn"
                    onClick={() => setShowConfirmation(true)}
                    disabled={!selectedReason}
                >
                    Delete Profile
                </button>
            </div>

            {/* Confirmation Dialog */}
            {showConfirmation && (
                <div className="confirmation-overlay">
                    <div className="confirmation-dialog">
                        <h3>Confirm Profile Deletion</h3>
                        <p>Are you sure you want to permanently delete your profile?</p>
                        {errorMessage && <p className="error-message">{errorMessage}</p>}
                        <div className="confirmation-buttons">
                            <button
                                className="confirm-btn"
                                onClick={handleDeleteConfirmation}
                                disabled={isDeleting}
                            >
                                {isDeleting ? 'Deleting...' : 'Yes'}
                            </button>
                            <button
                                className="cancel-confirm-btn"
                                onClick={() => setShowConfirmation(false)}
                                disabled={isDeleting}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DeleteProfile;